import { Link } from "react-router-dom";

// Shared split layout for the public auth pages (sign in / sign up / reset
// password): form on the left, a quiet product panel on the right (desktop).
const AuthShell = ({ title, subtitle, children, testId }) => (
  <div className="min-h-screen bg-white grid grid-cols-1 lg:grid-cols-2" data-testid={testId}>
    <div className="flex flex-col px-6 sm:px-12 py-8">
      <Link to="/" className="font-logo text-[22px] text-[#303030] self-start">Club Pass</Link>

      <div className="flex-1 flex items-center">
        <div className="w-full max-w-sm mx-auto lg:mx-0 lg:ml-[12%] py-12">
          <h1 className="font-display text-4xl font-semibold text-zinc-900 leading-tight">{title}</h1>
          {subtitle && <p className="text-zinc-500 mt-3">{subtitle}</p>}
          <div className="mt-10">{children}</div>
        </div>
      </div>

      <p className="text-xs text-zinc-400">
        <Link to="/privacy" className="hover:text-zinc-600">Privacy</Link>
        <span className="mx-2">·</span>
        <Link to="/terms" className="hover:text-zinc-600">Terms</Link>
      </p>
    </div>

    <div className="hidden lg:flex panel flex-col items-center justify-center px-12">
      <img
        src="/screenshots/pass-preview.png?v=2"
        alt="Example Club Pass membership pass"
        className="w-64 rounded-[22px] shadow-[0_30px_60px_-25px_rgba(0,0,0,0.45)]"
      />
      <p className="font-display text-2xl font-semibold text-zinc-900 mt-12 text-center max-w-sm leading-snug">
        Membership cards your members actually carry.
      </p>
      <p className="text-zinc-500 mt-3 text-center max-w-sm">
        Issued straight to Google Wallet, updated instantly.
      </p>
    </div>
  </div>
);

export default AuthShell;
